import { Button, Stack, Text, Title } from "@mantine/core";
import { IconThumbUp } from "@tabler/icons-react";

import styles from "./greeting.module.css";

interface Props {
    name: string;
    onDismiss: () => void;
    isDismissing: boolean;
}

export function Greeting({ name, onDismiss, isDismissing }: Props) {
    const displayName = name.trim().length > 0 ? name : "there";

    return (
        <Stack className={styles.root} gap="sm" align="flex-start">
            <Title order={1} className={styles.heading}>
                Hi, {displayName}.
            </Title>
            <Text className={styles.subtitle}>
                Here’s your performance snapshot from yesterday&mdash;see where you’re doing well and what to focus on
                today.
            </Text>
            <Button
                onClick={onDismiss}
                disabled={isDismissing}
                loading={isDismissing}
                radius="xl"
                size="xs"
                variant="default"
                leftSection={<IconThumbUp size={14} />}
                className={styles.dismissButton}
            >
                Start Shift
            </Button>
        </Stack>
    );
}
